//#region Imports
import React from 'react';

import '../scss/Elements/_tables.scss';
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import InventoryLocationsTable from '../components/Tables/InventoryLocationsTable';
//#endregion

function InventoryLocations() {
  const { titleInventoryString } = useTranslationHook();

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>{titleInventoryString}</title>
      </Helmet>
      <div className='datatable'>
        <InventoryLocationsTable />
      </div>
    </div>
  );
}

export default InventoryLocations;
